import { render } from "./MainPopup.vue?vue&type=template&id=011b3306&scoped=true"
import script from "./MainPopup.vue?vue&type=script&lang=js"
export * from "./MainPopup.vue?vue&type=script&lang=js"

import "./MainPopup.vue?vue&type=style&index=0&id=011b3306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011b3306"]])

export default __exports__